var SelectHandles = require('../selectSet/selectHandles');

/* return true of false to continue */

module.exports = {

    start:  function(x, y, e) {

        e.preventDefault();
        e.stopPropagation();

        // disallow if moving
        if (this.shapeUI.get( 'isMoving') )
            return false;

        this.shapeUI.set('isResizing', true); //handle centrally

        this.dragHandle = this.paper.getElementByPoint(x, y).attr({
            fill: SelectHandles.prototype.hoverFill
        });

        return true;
    },
    move: function(dx, dy, x, y, e) {

        e.preventDefault();
        e.stopPropagation();

        if (dx === 0 && dy === 0)
            return false;

        if ( !this.parent.mouseInBounds(x, y) )  //(ref to parent)
            return false;

        return true;
    },
    end: function(e) {

        e.preventDefault();
        e.stopPropagation();
        this.shapeUI.set({isResizing: false});
        return true;

    },
    cleanUp: function() {

        this.trigger('shape.resizeEnd'); // do after the shape is resized!
        this.dragHandle = null;

    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/resizeFns/baseShapeResizeFns.js
 ** module id = 194
 ** module chunks = 0
 **/